export { default } from './product-details.vue'
